// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shipping-cost-container-mobile {
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    margin-top: 20px;
    background: rgb(71 147 239 / 30%);
  }
  
  .summary-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    cursor: pointer;
  }
  
  .summary-title {
    font-weight: bold;
    font-size: 18px;
  }
  
  .summary-value {
    display: flex;
    align-items: center;
    font-weight: bold;
  }
  
  .arrow {
    border: solid black;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    margin-left: 8px;
  }
  
  .down {
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
  }
  
  .up {
    transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
  }
  
  .summary-content-mobile {
    padding: 16px;
  }
  
  .shipping-item-mobile {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
  }
  
  .shipping-item-mobile.total-mobile {
    font-weight: bold;
  }
  
  .split-divide-mobile {
    border-top: 1px solid gray;
    margin: 16px 0;
  }
  
  /* Media query for mobile view */
  @media (max-width: 870px) {
    .shipping-cost-container {
      display: none;
    }
  
    .shipping-cost-container-mobile {
      display: block;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/SummarOrderMobile/styles.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;IACxC,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,gCAAgC;EAClC;;EAEA;IACE,0BAA0B;IAC1B,kCAAkC;EACpC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,cAAc;EAChB;;EAEA,gCAAgC;EAChC;IACE;MACE,aAAa;IACf;;IAEA;MACE,cAAc;IAChB;EACF","sourcesContent":[".shipping-cost-container-mobile {\n    border-radius: 8px;\n    background: #fff;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    margin-top: 20px;\n    background: rgb(71 147 239 / 30%);\n  }\n  \n  .summary-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 16px;\n    cursor: pointer;\n  }\n  \n  .summary-title {\n    font-weight: bold;\n    font-size: 18px;\n  }\n  \n  .summary-value {\n    display: flex;\n    align-items: center;\n    font-weight: bold;\n  }\n  \n  .arrow {\n    border: solid black;\n    border-width: 0 2px 2px 0;\n    display: inline-block;\n    padding: 3px;\n    margin-left: 8px;\n  }\n  \n  .down {\n    transform: rotate(45deg);\n    -webkit-transform: rotate(45deg);\n  }\n  \n  .up {\n    transform: rotate(-135deg);\n    -webkit-transform: rotate(-135deg);\n  }\n  \n  .summary-content-mobile {\n    padding: 16px;\n  }\n  \n  .shipping-item-mobile {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 8px;\n  }\n  \n  .shipping-item-mobile.total-mobile {\n    font-weight: bold;\n  }\n  \n  .split-divide-mobile {\n    border-top: 1px solid gray;\n    margin: 16px 0;\n  }\n  \n  /* Media query for mobile view */\n  @media (max-width: 870px) {\n    .shipping-cost-container {\n      display: none;\n    }\n  \n    .shipping-cost-container-mobile {\n      display: block;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
